module.exports = __webpack_public_path__ + "img/bg-dispute-summary.b5e53f70.svg";